import {
  HeaderWithBulletPoints,
  FormB1,
  TwoHeadersAndBulletPoints,
} from '@chegg-wt/core/types/core'

export const confirmContent: HeaderWithBulletPoints[] = [
  {
    header: 'Why am I being shown what was and was not found?',
    body: [
      "When you searched for and selected your source, we used our resources to find as much citation information as possible for you. This is how we automatically cite sources! We can't always get all the information, so this page reminds you to be aware of what information was found, and what information could not be found.",
    ],
  },
  {
    header:
      'I thought Cite This For Me, a Chegg Service automatically finds all the information for me?',
    body: [
      "Cite This For Me citation generator looks at various databases and existing information to find the source's citation information. We do our best and are good at finding source information most of the time, but getting all of the required information is sometimes tricky and we can only pull information that the source's publisher has presented. So it's up to you to make sure that it's accurate and complete.",
    ],
  },
  {
    header:
      'Do I need to find all of the information that was not found in order to make a proper and complete citation?',
    body: [
      "Maybe. Depending on the citation style and source type, you may not need all the details we've focused on. The information that we present on this page simply highlights on the most commonly needed fields. Sources can still be cited if some of the highlighted information isn't found. ",
      'For example, some books do not have an author, editor, or contributor, but can still be cited (in the bibliography the source will be listed under its title).',
    ],
  },
  {
    header: 'Now what do I do?',
    body: [
      'If the information looks good, click "Continue" to move on to the citation form. There you can edit existing information and enter any missing details. If you aren\'t sure about the details, provide as much as you can and then move on. If you have an account with us, you can always come back and edit the citation later.',
      'If you want to choose a different sources or revise your search for a source, click "Back to Search results."',
    ],
  },
]

const formContent: TwoHeadersAndBulletPoints[] = [
  {
    header: 'Annotation',
    bodyHeader:
      'Brief summary of or your personal thoughts on a source. An annotation can be added to the end of a citation and can answer questions like:',
    body: [
      'What is the quality of the source?',
      'How does this source relate to your paper or project?',
      'What does the source focus on? ',
      'What are its strengths and weaknesses?',
    ],
  },
  {
    header: 'Author',
    bodyHeader:
      'Person who originally wrote or made a book, blog, poem, play, article, podcast, digital image, etc.',
  },
  {
    header: 'Contributor',
    bodyHeader:
      'Either a person, group, or organisation that contributed to a piece of work. This includes, but is not limited to, an editor, writer, performer, interviewer, and director.',
  },
  {
    header: 'Date Accessed',
    bodyHeader:
      'The month, day, and year a work was accessed or reviewed online. This information only applies to online resources like websites, online journal articles, etc.',
  },
  {
    header: 'DOI',
    bodyHeader:
      'DOI stands for “Digital Object Identifier.” A DOI can be used to identify a digital object and each is unique. Many journal articles have one. ',
    body: ['Example DOI: 10.1038/s41598-017-06948-9'],
  },
  {
    header: 'Electronically Published',
    bodyHeader:
      'The date (month, day, year) a work was published online. Not always shown on a webpage.',
  },
  {
    header: 'Medium',
    bodyHeader: 'The form in which a work was shared or published. Here is one example:',
    body: ['Painting/Artwork: Oil on wood, Watercolors on paper, Bronze, etc.'],
  },
  {
    header: 'Place of Publication',
    bodyHeader:
      'The city, state, or country of the publisher. Depending on the style, you may or may not need this information.',
  },
  {
    header: 'Publisher/Sponsor',
    bodyHeader:
      'Organisation or individual that facilitated the publishing or sharing of a source.',
  },
  {
    header: 'Suffix',
    bodyHeader:
      'Abbreviation tagged on to the end of a name that provides additional information about a person. This includes suffixes like Jr., Sr., II, etc.',
  },
  {
    header: 'Title',
    bodyHeader:
      'The title is what the work you are citing is called. If there is no title, some styles ask for a description of the source instead.',
  },
  {
    header: 'URL',
    bodyHeader:
      'URL is an acronym for Uniform Resource Locator. It is how you find a page on the Internet; the address of the web page. http://www.citethisforme.com/ is an example of a URL.',
  },
]

export const formB1: FormB1 = {
  header: 'Glossary of Selected Terms',
  table: formContent,
}
